<div class="flex justify-between items-center mb-2">
  <h1 class="main-title">Gestión de turnos > Turnos históricos > Detalle {{ this.subtitle }}</h1>
  <div>
    <!-- Botón de Previsualización - Solo disponible cuando se pueden generar informes -->
    <button
      *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno')"
      class="button button-outlined-primary button-sm mr-3"
      (click)="openPdfPreview()"
    >
      Previsualización
    </button>
    
    <ng-container *ngIf="!hasShiftReport && type === 'turno_diario'">
      <button class="button button-warning button-sm mr-3" (click)="shiftClosure()">
        Cierre de turno diario
      </button>
    </ng-container>
    <ng-container *ngIf="!hasShiftReport && type === 'informe_turno'">

      <button class="button button-warning button-sm mr-3" (click)="shiftClosure()">
        Generar informe de turno
      </button>
    </ng-container>
    <a class="button button-outlined-primary button-sm" routerLink="/historical-shift">
      <i class="fa-solid fa-chevron-left" alt=""></i> Volver
    </a>
  </div>
</div>
<div class="box mb-4" *ngIf="isJefeTurno">
  <h2 class="main-subtitle">Novedades del turno</h2>

  <h3>Seguridad / Calidad / Medio Ambiente</h3>
  <app-table
    class="table-news table-switch"
    [columns]="showSelectableColumns ? shiftUpdatesTableColumns : shiftUpdatesTableColumnsRO"
    [data]="seguridadCalidadMedioAmbiente"
    [tableType]="'seguridad_calidad'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') " (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Personal</h3>
  <app-table
    class="table-news table-switch"
    [columns]="showSelectableColumns ? shiftUpdatesTableColumns : shiftUpdatesTableColumnsRO"
    [data]="personalData"
    [tableType]="'personal'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno')" (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div>


@if(type === 'turno_diario'){
<div class="box">
  <!-- Iterar sobre cada área y crear una tabla para cada una -->
  <div *ngFor="let areaName of areaNames" class="mb-6">
    <h2 class="main-subtitle">{{ areaName }}</h2>
    <app-table
      class="table-news table-switch"
      [columns]="generalTableColumns"
      [data]="groupedGeneralData[areaName]"
      [tableType]="areaName"
      (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
      (selectAllChange)="onSelectAllChange($event)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)" title="Ver">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
          <!-- <button (click)="openCloneConfirmation(visation)" title="Clonar">
            <img src="assets/icons/copy-icon.svg" alt="">
          </button> -->
          <button (click)="editUpdateRecord(visation)" title="Editar">
            <img src="assets/icons/pencil-icon.svg" alt="">
          </button>
          <!-- 
          <button *ngIf="visation.isCloned" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="">
          </button> -->
        </div>
      </ng-template>
    </app-table>
  </div>

  <h2 class="main-subtitle">Aviso de averías solicitado</h2>
  <app-table
    class="table-news table-switch"
    [columns]="reportedBreakdownNoticeTableColumns"
    [data]="flattenedData['aviso_averias']"
    [tableType]="'aviso_averias'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <!-- <button (click)="openCloneConfirmation(visation)" title="Clonar">
          <img src="assets/icons/copy-icon.svg" alt="">
        </button> -->
        <button (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="">
        </button>
        <!--
        <button *ngIf="visation.isCloned" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="">
        </button> -->
      </div>
    </ng-template>
  </app-table>
</div>
}@else{
<div class="box" >
  <h2 class="main-subtitle">Novedades del turno por área</h2>
  
  <app-table 
    class="table-news table-switch" 
    [columns]="showSelectableColumns ? generalTableColumns : generalTableColumnsRO" 
    [data]="flattenedData['novedades']"
    [tableType]="'novedades'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') " (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Aviso de averías solicitado</h3>
  <app-table 
    class="table-news table-switch" 
    [columns]="showSelectableColumns ? reportedBreakdownNoticeTableColumns : reportedBreakdownNoticeTableColumnsRO" 
    [data]="flattenedData['aviso_averias']"
    [tableType]="'aviso_averias'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') " (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
        
      </div>
    </ng-template>
  </app-table>

  <h3 class="mt-10">Orden de Trabajo</h3>
  <div style="width: 100%; overflow: auto">
    <app-table 
      class="table-news table-switch" 
      [columns]="showSelectableColumns ? workOrderTableColumns : workOrderTableColumnsRO" 
      [data]="flattenedData['o_t_ejecutadas']"
      [tableType]="'o_t_ejecutadas'"
      (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
      (selectAllChange)="onSelectAllChange($event)"
    >
      <ng-template #actionTemplate let-visation>
        <div class="action-buttons">
          <button (click)="viewUpdateRecord(visation)" title="Ver">
            <img src="assets/icons/eye-icon.svg" alt="" />
          </button>
          <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') " (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
          <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
            <img src="assets/icons/trashcan-icon.svg" alt="" />
          </button>
        </div>
      </ng-template>
    </app-table>
  </div>

  <h3 class="mt-10">Fuera de servicios</h3>
  <app-table 
    class="table-news table-switch" 
    [columns]="showSelectableColumns ? outOfServiceTableColumns : outOfServiceTableColumnsRO" 
    [data]="flattenedData['fuera_servicio']"
    [tableType]="'fuera_servicio'"
    (checkboxChange)="onCheckboxChangeForClosure($event.checked, $event.id)"
    (selectAllChange)="onSelectAllChange($event)"
  >
    <ng-template #actionTemplate let-visation>
      <div class="action-buttons">
        <button (click)="viewUpdateRecord(visation)" title="Ver">
          <img src="assets/icons/eye-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') " (click)="editUpdateRecord(visation)" title="Editar">
          <img src="assets/icons/pencil-icon.svg" alt="" />
        </button>
        <button *ngIf="!hasShiftReport && (type === 'turno_diario' || type === 'informe_turno') && canDelete(visation)" (click)="deleteUpdateRecord(visation.id)" title="Eliminar">
          <img src="assets/icons/trashcan-icon.svg" alt="" />
        </button>
      </div>
    </ng-template>
  </app-table>
</div> 
  }



